import track from './eventTracker';

const StyleShuffleShopTracker = new (function () {
  this.trackPDPViewEvent = ({
    skuId,
    externalProductId,
    source,
    subSource,
    collection,
    relatedItemsSkuIds,
  }) => {
    return track({
      event_name: 'categories.interaction',
      canonical_name: 'pdp',
      action_type: 'view',
      action_name: 'pdp_view',
      sku_id: skuId,
      external_product_id: externalProductId,
      source,
      sub_source: subSource,
      collection,
      similar_items: relatedItemsSkuIds,
    });
  };

  this.trackBuyNowEvent = ({
    collection,
    skuId,
    externalProductId,
    relatedItemSkuIds,
    source,
    subSource,
  }) => {
    track({
      event_name: 'categories.interaction',
      canonical_name: 'pdp',
      action_type: 'click',
      action_name: 'buy_now',
      sku_id: skuId,
      external_product_id: externalProductId,
      collection,
      related_item_sku_ids: relatedItemSkuIds,
      source,
      order_type: 'categories',
      sub_source: subSource,
    });
  };
})();

export default StyleShuffleShopTracker;
